import {Injectable} from '@angular/core';
import {ApiService} from '../../../core/services/api.service';
import {ApiResponse} from '../../../core/shared/classes/api';
import {Observable} from 'rxjs';

@Injectable()
export class AgrementsClientService {
    constructor(private  apiService: ApiService) {}

    public fetchAll(roleId): Observable<ApiResponse> {
        return this.apiService.get(`agements_client/roles/${roleId}`);
    }

    public fetchById(id): Observable<ApiResponse> {
        return this.apiService.get(`agements_client/${id}`);
    }

    public create(data): Observable<ApiResponse> {
        return this.apiService.post('agements_client', JSON.stringify(data));
    }

    public update(id, data): Observable<ApiResponse> {
        return this.apiService.put(`agements_client/${id}`, JSON.stringify(data));
    }

    public delete(id): Observable<ApiResponse> {
        return this.apiService.delete(`agements_client/${id}`);
    }

    public fetchByLotsId(data): Observable<ApiResponse> {
        return this.apiService.post(`agements_client/lots`, JSON.stringify(data));
    }
    
    public fetchByLotId(id): Observable<ApiResponse> {
        return this.apiService.get(`agements_client/lot/${id}`);
    }
}
